<div class="w-full h-full absolute drag-boundary">
  <div
    *ngFor="let task of backgroundTasks; let isFirst = first"
    class="float-label"
    cdkDrag
    cdkDragBoundary=".drag-boundary"
    style="transform: translate3d(1610px, 171px, 0px)"
    [style.margin-top]="!isFirst ? '45px' : null"
  >
    <div class="float-label-sob" [style.color]="getColor('Offense')">Offense</div>

    <div class="float-label-text">Upload in progress...</div>

    <div class="progres">
      <div
        class="w-full h-[25px] rounded-full flex overflow-hidden bg-[#D9D9D9] text-[0.75rem] relative"
      >
        <span
          class="absolute left-[49%] font-medium text-base"
          [ngClass]="65 > 53 ? 'text-white' : 'text-black'"
          >{{ 65 }} %</span
        >
        <div
          class="rounded-full flex flex-col justify-center overflow-hidden text-white text-center whitespace-nowrap transition-[width] duration-[600ms] motion-reduce:transition-none bg-[#0066FF] bg-[linear-gradient(45deg,rgba(255,255,255,0.15)_25%,transparent_25%,transparent_50%,rgba(255,255,255,0.15)_50%,rgba(255,255,255,0.15)_75%,transparent_75%,transparent)] bg-[length:1rem_1rem] motion-safe:animate-[upload-stripes_1s_linear_infinite]"
          role="progressbar"
          [style.width.%]="65"
        ></div>
      </div>
    </div>
  </div>
</div>
